import { render, staticRenderFns } from "./common.vue?vue&type=template&id=efd23174"
import script from "./common.vue?vue&type=script&lang=js"
export * from "./common.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports